module.exports = __webpack_public_path__ + "img/directions_walk.02d75b22.svg";